import errorHandler from '@/utils/errorHandler'

export default {
    methods: {
        errorHandler(error) {
            return errorHandler(this, error)
        },
    },
}